// Video and image optimization helpers using Cloudinary transformations
import { optimizeCloudinaryUrl } from './videoConfig';

/**
 * Optimizes a video URL for delivery with Cloudinary transformations.
 * Applies compression, format optimization, and size limiting.
 */
export function optimizeVideoUrlAutoGood(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  return optimizeCloudinaryUrl(url, true);
}

/**
 * Generates a poster/thumbnail image URL from a Cloudinary video.
 * Uses Cloudinary's video thumbnail generation feature.
 */
export function getCloudinaryVideoPosterUrl(url: string | null | undefined): string | undefined {
  if (!url || !url.includes('cloudinary.com')) return undefined;
  
  // Generate a poster from the video at 1 second
  const parts = url.split('/upload/');
  if (parts.length !== 2) return undefined;
  
  const [baseUrl, assetPath] = parts;
  // Remove video extension and add image transformations
  const assetWithoutExt = assetPath.replace(/\.(mp4|mov|webm|avi)$/i, '.jpg');
  
  const posterTransformations = [
    'q_auto:good',
    'f_auto',
    'w_900',
    'c_limit',
    'so_1.0' // Start offset at 1 second
  ].join(',');
  
  return `${baseUrl}/upload/${posterTransformations}/${assetWithoutExt}`;
}


